<template>
  <section class="document-additional-info">
    <h5 class="h5 font-bold">Información adicional</h5>
    <b-row v-for="(adittional, index) in additionals" :key="index" class="my-3">
      <b-col xs="12" sm="5" md="5">
        <el-input
          type="text"
          placeholder="Nombre"
          class=""
          v-model="adittional.name"
          @blur="onInputBlur"
        ></el-input>
        <small v-if="isReservedName(adittional.name)" class="text-danger">
          "{{ rucProveedorLabel }}" lo agrega Mydessk automáticamente. Usa otro
          nombre.
        </small>
      </b-col>
      <b-col xs="11" sm="5" md="5">
        <el-input
          type="text"
          placeholder="Descripción"
          class=""
          v-model="adittional.description"
          @blur="onInputBlur"
        ></el-input>
      </b-col>
      <b-col xs="1" sm="1" md="1">
        <ButtonIcoComponent
          v-if="additionals.length > 1"
          class="float-right"
          @onClick="removeAdditional(index)"
        />
      </b-col>
    </b-row>
    <el-tooltip
      v-for="field in lockedFields"
      :key="field.label"
      content="Requerido por el SRI. Lo agrega Mydessk automáticamente."
      placement="top-start"
    >
      <b-row class="my-3 document-additional-info__locked" tabindex="-1">
        <b-col xs="12" sm="5" md="5">
          <div class="locked-field">
            <i class="el-icon-lock locked-field__icon"></i>
            <span>{{ field.label }}</span>
          </div>
        </b-col>
        <b-col xs="11" sm="5" md="5">
          <div class="locked-field locked-field--muted">{{ field.value }}</div>
        </b-col>
      </b-row>
    </el-tooltip>
    <el-alert
      v-if="filledAdditionals.length > maxTenantAdditionals"
      type="warning"
      :closable="false"
      show-icon
      :title="
        `El SRI permite ${maxTenantAdditionals} campos adicionales además del RUC Proveedor. Al emitir se excluirán los últimos ${filledAdditionals.length -
          maxTenantAdditionals}.`
      "
    ></el-alert>
  </section>
</template>

<script>
import ButtonIcoComponent from "../../components/ButtonIco";

// Campo exigido por el SRI (NAC-DGERCGC26-00000027); el backend lo inyecta en todo comprobante.
const RUC_PROVEEDOR_LABEL = "RUC Proveedor";
const SRI_MAX_INFO_ADICIONAL = 15;
// Mismo texto que el RIDE (config/sri.php del backend). Valores globales de la plataforma.
const LOCKED_FIELDS = [
  { label: "RUC Proveedor Facturación Electrónica", value: "0925739534001" },
  { label: "Proveedor Facturación Electrónica", value: "Mydessk" }
];
const normalizeName = name =>
  String(name || "")
    .trim()
    .replace(/\s+/g, " ")
    .replace(/[\s:]+$/, "")
    .toLowerCase();

export default {
  name: "DocumentAdditionalInfoComponent",
  data() {
    return {
      additionals: this.additionalExtras,
      rucProveedorLabel: RUC_PROVEEDOR_LABEL,
      lockedFields: LOCKED_FIELDS,
      maxTenantAdditionals: SRI_MAX_INFO_ADICIONAL - 1
    };
  },
  computed: {
    filledAdditionals() {
      return this.additionals.filter(
        item => item.name && item.description && !this.isReservedName(item.name)
      );
    }
  },
  watch: {
    additionalExtras(value) {
      this.additionals = value;
    }
  },
  methods: {
    isReservedName(name) {
      return (
        !!name && normalizeName(name) === normalizeName(RUC_PROVEEDOR_LABEL)
      );
    },
    onInputBlur() {
      const lastAdditionalInfo = this.additionals[this.additionals.length - 1];
      if (lastAdditionalInfo.name && lastAdditionalInfo.description) {
        this.additionals = [
          ...this.additionals,
          ...[
            {
              name: null,
              description: null
            }
          ]
        ];
      }

      this.onToogleAdditionals();
    },
    removeAdditional(index) {
      this.additionals.splice(index, 1);
      this.onToogleAdditionals();
    },
    onToogleAdditionals() {
      this.$emit("onAdditionals", { additionals: this.additionals });
    }
  },
  props: {
    additionalExtras: {
      type: Array,
      default: () => []
    }
  },
  components: {
    ButtonIcoComponent
  },
  mounted() {
    if (!this.additionalExtras.length) {
      this.additionals = [
        {
          name: null,
          description: null
        }
      ];
    }
  }
};
</script>

<style>
.document-additional-info__locked {
  cursor: not-allowed;
  outline: none;
}
.document-additional-info__locked .locked-field {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  padding: 0 4px;
  border-bottom: 1px dashed #dcdfe6;
  color: #606266;
  font-size: 14px;
  user-select: none;
}
.document-additional-info__locked .locked-field--muted {
  color: #a8abb2;
}
.document-additional-info__locked .locked-field__icon {
  flex-shrink: 0;
  color: #a8abb2;
}
</style>
